import { render, staticRenderFns } from "./EditTraining.vue?vue&type=template&id=e8bedae2&"
import script from "./EditTraining.vue?vue&type=script&lang=js&"
export * from "./EditTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports